import { useEffect, useState } from "react";
import { Monitor, Moon, Sun } from "lucide-react";

import { Button } from "@/components/ui/Button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/DropdownMenu";
import { getStoredTheme, resolveTheme, setTheme, type Theme } from "@/lib/theme";

export function ThemeToggle(): JSX.Element {
  const [theme, setLocalTheme] = useState<Theme>("system");

  useEffect(() => {
    setLocalTheme(getStoredTheme());
  }, []);

  const onPick = (t: Theme): void => {
    setLocalTheme(t);
    setTheme(t);
  };

  const effective = resolveTheme(theme);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" aria-label="Тема">
          {effective === "dark" ? (
            <Moon className="h-4 w-4" />
          ) : (
            <Sun className="h-4 w-4" />
          )}
          <span className="sr-only">Перемкнути тему</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => onPick("light")}>
          <Sun className="mr-2 h-4 w-4" />
          Світла
          {theme === "light" ? <span className="ml-auto">✓</span> : null}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onPick("dark")}>
          <Moon className="mr-2 h-4 w-4" />
          Темна
          {theme === "dark" ? <span className="ml-auto">✓</span> : null}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onPick("system")}>
          <Monitor className="mr-2 h-4 w-4" />
          Системна
          {theme === "system" ? <span className="ml-auto">✓</span> : null}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
